import React, { useContext } from 'react'
import { string } from 'prop-types'
import { getCDNURL } from 'network/api/networkSettings'
import { LanguageContext } from 'context/LanguageContext'

export const Spinner = ({ width, height, container = true, className, placeOrderPopUp }) => {
    const { strings } = useContext(LanguageContext)
    const Content = (
        <div className={'d-flex justify-content-center enter_otp_spinner'}>
            <img
                className={'loader-circle'}
                src={getCDNURL() + 'assets/gifs/loader.gif'}
                alt={strings.loading}
                style={{ width: `${width}`, height: `${height}` }}
            />
        </div>
    )
    if (!container) {
        return Content
    }
    return <div className={`${placeOrderPopUp ? 'spinner-wrapper-placeOrder' : 'spinner-wrapper'} ${className}`}>{Content}</div>
}

Spinner.propTypes = {
    height: string,
    width: string,
}

export default Spinner
